/* tslint:disable */

declare var Object: any;
export interface ProfessionCategoryInterface {
  "code": string;
  "name": string;
  "professions": Array<any>;
  "id"?: any;
}

export class ProfessionCategory implements ProfessionCategoryInterface {
  "code": string;
  "name": string;
  "professions": Array<any>;
  "id": any;
  constructor(data?: ProfessionCategoryInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `ProfessionCategory`.
   */
  public static getModelName() {
    return "ProfessionCategory";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of ProfessionCategory for dynamic purposes.
  **/
  public static factory(data: ProfessionCategoryInterface): ProfessionCategory{
    return new ProfessionCategory(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'ProfessionCategory',
      plural: 'ProfessionCategories',
      properties: {
        "code": {
          name: 'code',
          type: 'string'
        },
        "name": {
          name: 'name',
          type: 'string'
        },
        "professions": {
          name: 'professions',
          type: 'Array&lt;any&gt;'
        },
        "id": {
          name: 'id',
          type: 'any'
        },
      },
      relations: {
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/sdk/models/ProfessionCategory.ts